module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/work-cbf35c3517d8082e459b2facc00c38a7.svg";